<template>
  <div class="epic-widget-launcher-actions">
    <sp-button variant="outlined" @click="close">{{ t("cancel_label") }}</sp-button>
    <sp-button type="submit" :disabled="!canSubmit" :data-testid="TestId.epicWidgetLauncher.submit">
      {{ t("submit_label") }}
    </sp-button>
  </div>
</template>

<script setup>
import { TestId } from "#/test-ids";
import { t } from "#ce/apps/SpAdmin/SpEpicWidgetLauncher/i18n";
import { useEpicWidgetLauncherStore } from "#ce/apps/SpAdmin/SpEpicWidgetLauncher/store/epic-widget-launcher";

const { canSubmit, close } = useEpicWidgetLauncherStore();
</script>

<style scoped lang="scss">
.epic-widget-launcher-actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--sp-ref-scale-16);
  inline-size: 100%;
}
</style>
